/*
 * 客户模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取客户信息
    getCustomerList(data) {
        // return get('/app/customer', data)
        return post('/wx/customer/list', data, 'javaHost')
    },
    // 客户详情
    getCustomerDetail(data) {
        // return get('/app/customer', data)
        return get('/wx/customer/detail', data, 'javaHost')
    },
    // 编辑客户
    updateCustomer(data) {
        // return put('/app/customer', data)
        return post('/wx/customer/edit', data, 'javaHost')
    },

    // 创建建筑信息
    addBuildingInfo(data) {
        // return post('/app/customer/building_info', data)
        return post('/wx/customer/building/add', data, 'javaHost')
    },
    // 编辑建筑信息
    updateBuildingInfo(data) {
        // return put('/app/customer/building_info', data)
        return post('/wx/customer/building/edit', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/customer.js